
(function() {
const section = document.querySelector('.faq-new-section');
if (!section) return;

const questions = section.querySelectorAll('.faq-new-question');
questions.forEach(question => {
    question.addEventListener('click', function() {
    const answer = this.nextElementSibling;
    const isActive = this.classList.contains('active');
    // Close all other FAQ items
    questions.forEach(q => {
        if (q !== this) {
        q.classList.remove('active');
        q.setAttribute('aria-expanded', 'false');
        const otherAnswer = q.nextElementSibling;
        if (otherAnswer) {
            otherAnswer.classList.remove('active');
            otherAnswer.setAttribute('aria-hidden', 'true');
        }
        }
    });
    
    // Toggle current FAQ item
    if (isActive) {
        this.classList.remove('active');
        this.setAttribute('aria-expanded', 'false');
        answer.classList.remove('active');
        answer.setAttribute('aria-hidden', 'true');
    } else {
        this.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
        answer.classList.add('active');
        answer.setAttribute('aria-hidden', 'false');
    }
    });
});
})();
